var _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlowingHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125 125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      animation: "pulsate 1.5s infinite ease-out"
    },
    cx: 62.5,
    cy: 62.5,
    r: 47.5,
    fill: "#57DCD8",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      animation: "pulsate 1.5s infinite ease-out",
      animationDelay: "350ms"
    },
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#7A43CB",
    fillOpacity: 0.28
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 32.5,
    fill: "url(#glowing-heart-gradient)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glowing-heart-gradient",
    x1: 62.5,
    y1: 30,
    x2: 62.5,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ba7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ba7df"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingHeart);
export default __webpack_public_path__ + "static/media/GlowingHeart.c78592375f7a900909a4ed27520316f2.svg";
export { ForwardRef as ReactComponent };